module.exports = __webpack_public_path__ + "img/5@2x.1d71131b.png";